<script>
  import { imageUrl, getStyleValue } from "../../Common/tools";
  import {External, M} from "../../external";

  export let data,
    globalStyle,
    isChild = false,
    style = "padding-left: 40px; padding-right: 10px; text-align: left;";
  const placeholder = External.resources + "/images/marketing/placeholders/139x34.png";

  let align;
  $: {
    if (!data.style.position || data.style.position === "" || data.style.position === "left") {
      align = "component-left";
    } else if (data.style.position === "center") {
      align = "component-center";
    } else {
      align = "component-right";
    }
  }
</script>

<tr valign="top">
  <th class="column column-st" width={getStyleValue(globalStyle.width, 600)} align={data.style.position || "left"}>
    <img src={imageUrl(data, placeholder)} class={align} style="display: block;" width={getStyleValue(data.style.width, 139)} border="0" alt="{M.LOGO}" />
  </th>
</tr>
